import { useCallback, useEffect, useRef, useState } from 'react'
import { MIN_BAR_PX, MAX_BAR_PX } from './dictationConstants.js'
import { DICTATION_BAR_COUNT, startDictationSession } from './useDictationAudioSession.js'
import { finalizeDictationSession, stopDictationSession } from './finalizeDictationSession.js'









/**
 * @param {{ isActive: boolean, onMicError?: (err: Error) => void }} options
 */

export function useDictationAudio({ isActive, onMicError }) {
  const levelsRef = useRef(new Float32Array(DICTATION_BAR_COUNT))
  const sessionRef = useRef(null)
  const [levels, setLevels] = useState(() => new Float32Array(DICTATION_BAR_COUNT))
  const [micError, setMicError] = useState(null)
  const onMicErrorRef = useRef(onMicError)

  useEffect(() => {
    onMicErrorRef.current = onMicError
  }, [onMicError])

  useEffect(() => {
    if (!isActive) return undefined

    let cancelled = false
    queueMicrotask(() => setMicError(null))

    startDictationSession({
      cancelled: () => cancelled,
      levelsRef,
      setLevels,
      sessionRef,
      onError: (message, err) => {
        setMicError(message)
        onMicErrorRef.current?.(err)
      },
    }).catch((err) => {
      if (!cancelled) {
        const message = err instanceof Error ? err.message : 'Microphone unavailable'
        setMicError(message)
        onMicErrorRef.current?.(err instanceof Error ? err : new Error(message))
      }
    })

    return () => {
      cancelled = true
      const session = sessionRef.current
      stopDictationSession(session)
      sessionRef.current = null
    }
  }, [isActive])

  const finalizeSession = useCallback(async (wantBlob) => {
    const session = sessionRef.current
    const blob = await finalizeDictationSession(session, wantBlob)
    sessionRef.current = null
    return blob
  }, [])

  return { levels, micError, finalizeSession, minBarPx: MIN_BAR_PX, maxBarPx: MAX_BAR_PX }
}
